import React from "react";
import { processSteps } from "../../data/process";
export function ProcessSection() {
  return <section className="w-full bg-ink py-20 text-white md:py-28" data-id="element-134" data-mp="gtfu9lrnf83n">
      <div className="mx-auto max-w-7xl px-5 md:px-8" data-id="element-135" data-mp="gs4vk0d28qje">
        <div className="max-w-2xl" data-id="element-136" data-mp="btjqnnmv5iom">
          <h2 className="text-4xl font-semibold leading-[1.05] tracking-tight md:text-5xl" data-id="element-137" data-mp="bwphb7b54smg">
            Du premier appel à la mise en service,{" "}
            <span className="text-lime" data-id="element-138" data-mp="2v84bxt1571z">sans surprise</span>
          </h2>
          <p className="mt-5 text-lg leading-relaxed text-white/70" data-id="element-139" data-mp="3u943m9pbfj8e">
            Un interlocuteur unique vous accompagne à chaque étape de votre projet.
          </p>
        </div>

        <ol className="relative mt-16 grid gap-10 md:grid-cols-4 md:gap-8" data-id="element-140" data-mp="3p7eux0pkfhnh">
          <div className="absolute left-0 right-0 top-6 hidden h-px bg-white/15 md:block" aria-hidden="true" data-id="element-141" data-mp="3kchjxo8q6y7y" />
          {processSteps.map((step, i) => <li key={step.title} className="relative flex gap-5 md:block" data-id="element-142" data-mp="3bahzsn2eze0s" data-mpi={i}>
              <span className={`relative flex h-12 w-12 shrink-0 items-center justify-center rounded-full text-lg font-semibold ${i === 0 ? "bg-lime text-ink" : "border border-white/25 bg-ink text-white"}`} data-id="element-143" data-mp="3oc460rt5lh29">
                {i + 1}
              </span>
              <div className="md:mt-7" data-id="element-144" data-mp="3jelt6qc0mhoz">
                <h3 className="text-xl font-semibold tracking-tight" data-id="element-145" data-mp="ay94vnlqzy7m">{step.title}</h3>
                <p className="mt-2 leading-relaxed text-white/65" data-id="element-146" data-mp="awg0keylxq2s">{step.description}</p>
              </div>
            </li>)}
        </ol>
      </div>
    </section>;
}